/* eslint-disable  @typescript-eslint/no-explicit-any */
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit, Inject, Optional } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { datePickerMinDate, linkPattern, noWhitespaceInRequiredValidator, password_validation } from '../../../shared/constants';
import { noop } from 'jquery';
import { addDays } from 'date-fns';
import { NavbarComponent } from '../../../navbar/navbar.component';

@Component({
	selector: 'app-news-form',
	templateUrl: './news-form.component.html',
	styleUrl: './news-form.component.css'
})
export class NewsFormComponent {
	moduleForm: FormGroup = this.formBuilder.group({
		news: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		link: [null, [Validators.pattern(linkPattern)]],
		start_date: [/* null */new Date(), [Validators.required, noWhitespaceInRequiredValidator]],
		end_date: [/* null */addDays(new Date(), 3), [Validators.required, noWhitespaceInRequiredValidator]],
	});
	showLoader = false;
	pageLoading1 = false;
	@Input() uId: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	formSubmitted = false;
	details: any = null;
	minDate = datePickerMinDate;

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) { }

	initForm(uId: any) {
		this.uId = uId;
		if (this.uId) {
			this.getDetails();
		} else {
			this.moduleForm.reset();
			this.formSubmitted = false;
			this.uId = null;
		}
	}

	get f() { return this.moduleForm.controls; }

	clearForm() {
		this.uId = null;
		this.moduleForm.reset();
		this.formSubmitted = false;
		this.cleared.emit();
	}

	getDetails() {
		this.pageLoading1 = true;
		this.apiService.getNews({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.details = data;
				this.f.news.setValue(this.details.news);
				this.f.link.setValue(this.details.link);
				this.f.start_date.setValue(this.apiService.getDateFromDateString(this.details.start_date, 'YYYY-MM-DD'));
				this.f.end_date.setValue(this.apiService.getDateFromDateString(this.details.end_date, 'YYYY-MM-DD'));
			}, error: (error) => {
				this.pageLoading1 = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {
					noop;
				}
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		const data: any = {
			news: this.f.news.value,
			link: this.f.link.value,
			start_date: this.apiService.getDateStringFromDate(this.f.start_date.value, 'YYYY-MM-DD'),
			end_date: this.apiService.getDateStringFromDate(this.f.end_date.value, 'YYYY-MM-DD'),
		};
		if (this.uId) {
			data.id = this.uId;
		}
		this.showLoader = true;
		this.apiService.createUpdateNews(data).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				let errorMsg = "Something went wrong.";
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}
}
